// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function reason_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var reason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "reason"), null));
    if (reason.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                reason: reason._0
              }
            };
    }
    var e = reason._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".reason" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var reasons = Decco.listFromJson(reason_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "reasons"), null));
  if (reasons.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              reasons: reasons._0
            }
          };
  }
  var e = reasons._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".reasons" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  reason_decode ,
  t_decode ,
  
}
/* No side effect */
